const AllergyAlertCard = ({
  isMobile,
  allergyName = "Unconfirmed",
  reaction = "Unknown",
  verification = "Unconfirmed",
  onsetDate = "Unspecified",
  isDarkTheme = true,
}) => {
  const styles = {
    container: {
      backgroundColor: isDarkTheme ? "rgba(39, 38, 82, 1)" : "#f0f1ff",
      borderRadius: "16px",
      padding: isMobile ? "0.5rem" : "0.75rem",
      color: isDarkTheme ? "#fff" : "#333",
    },
    header: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: "0.375rem",
      marginBottom: "0.5rem",
    },
    iconContainer: {
      minWidth: isMobile ? "14px" : "16px",
      minHeight: isMobile ? "14px" : "16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    allergyName: {
      fontSize: isMobile ? "0.875rem" : "1rem",
      margin: 0,
      fontWeight: "bold",
      color: isDarkTheme ? "#fff" : "#333",
    },
    detailsContainer: {
      display: "flex",
      flexDirection: "column",
      gap: "0.375rem",
    },
    detailRow: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      marginBottom: "0.25rem",
    },
    detailLabel: {
      color: isDarkTheme ? "#a0a0a0" : "#666",
      fontWeight: "medium",
      width: isMobile ? "100%" : "9rem",
      fontSize: isMobile ? "0.75rem" : "0.875rem",
    },
    detailValue: {
      fontWeight: "bold",
      fontSize: isMobile ? "0.75rem" : "0.875rem",
      color: isDarkTheme ? "#fff" : "#333",
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        {/* Custom Circle icon */}
        <div style={styles.iconContainer}>
          <svg
            width={isMobile ? "14" : "16"}
            height={isMobile ? "14" : "16"}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="10" fill="#22C55E" stroke="#22C55E" />
          </svg>
        </div>

        {/* Custom Alert Circle icon */}
        <div style={styles.iconContainer}>
          <svg
            width={isMobile ? "14" : "16"}
            height={isMobile ? "14" : "16"}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="10" stroke="#FDBA74" strokeWidth="2" />
            <line
              x1="12"
              y1="8"
              x2="12"
              y2="12"
              stroke="#FDBA74"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <circle cx="12" cy="16" r="1" fill="#FDBA74" />
          </svg>
        </div>

        {/* Custom Bar Chart icon */}
        <div style={styles.iconContainer}>
          <svg
            width={isMobile ? "14" : "16"}
            height={isMobile ? "14" : "16"}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect x="4" y="14" width="4" height="6" rx="1" fill="#F87171" />
            <rect x="10" y="8" width="4" height="12" rx="1" fill="#F87171" />
            <rect x="16" y="4" width="4" height="16" rx="1" fill="#F87171" />
          </svg>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <h5 style={styles.allergyName}>{allergyName}</h5>
        </div>
      </div>

      <div style={styles.detailsContainer}>
        <div style={styles.detailRow}>
          <span style={styles.detailLabel}>Reaction: </span>
          <span style={styles.detailValue}>{reaction}</span>
        </div>

        <div style={styles.detailRow}>
          <span style={styles.detailLabel}>Verification: </span>
          <span style={styles.detailValue}>{verification}</span>
        </div>

        <div style={styles.detailRow}>
          <span style={styles.detailLabel}>Onset Date: </span>
          <span style={styles.detailValue}>{onsetDate}</span>
        </div>
      </div>
    </div>
  );
};

export default AllergyAlertCard;
